import { useEffect, useRef, useState } from 'react';

const ROW_HEIGHT = 45;
const HEADER_HEIGHT = 41;
const FOOTER = 72;
const MIN_ROWS = 5;

const estimate = (top: number) =>
  Math.max(MIN_ROWS, Math.floor((window.innerHeight - top - HEADER_HEIGHT - FOOTER) / ROW_HEIGHT));

export const useFittedPageSize = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [pageSize, setPageSize] = useState(() => estimate(300));

  useEffect(() => {
    const measure = () => {
      const el = tableRef.current;
      if (!el) return;
      setPageSize(estimate(el.getBoundingClientRect().top));
    };
    measure();
    window.addEventListener('resize', measure);
    const observer = new ResizeObserver(measure);
    if (tableRef.current?.parentElement) observer.observe(tableRef.current.parentElement);
    return () => {
      window.removeEventListener('resize', measure);
      observer.disconnect();
    };
  }, []);

  return { tableRef, pageSize };
};
